// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__pP91s","innerWrapper":"Table_innerWrapper__14aHy","json":"Table_json__1T8Zi","null":"Table_null__Y9L8l","link":"Table_link__26Alu"};